import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import PackagesTable from "@/components/logistics/packages/packages-table";

const packagesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/logistics/packages/")({
  validateSearch: packagesSearchSchema,
  component: PackagesPage,
});

function PackagesPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <PackagesTable
        currentPage={searchParams.page}
        pageSize={10}
        basePath="/logistics/packages"
        searchParams={searchParams}
      />
    </div>
  );
}
